import { createSelector } from 'reselect'
import { Map } from 'immutable'
import { getIn, getInOr } from 'utils/immutable'
import { getFeatureModuleName } from 'selectors/feature/featureMetadata'

const fastFeatureSelector = (state) => state.get('fastFeature')
const signalsForModules = getIn(['feature', 'signals'])
const conditionsSelector = getInOr(Map(), [
  'feature',
  'currentFeature',
  'conditions',
])

export const getFastFeatureIsFastFeature = createSelector(
  fastFeatureSelector,
  (ff) => ff.get('isFastFeature')
)

export const getFastFeatureIsToggling = createSelector(
  fastFeatureSelector,
  (ff) => ff.get('isToggling')
)

export const getFastFeatureIsSaving = createSelector(
  fastFeatureSelector,
  (ff) => ff.get('isSaving')
)

export const getFastFeatureFeatureId = createSelector(
  fastFeatureSelector,
  (ff) => ff.get('featureId')
)

export const getFastFeatureError = createSelector(fastFeatureSelector, (ff) =>
  ff.get('error')
)

export const getFeatureSwitchNumber = createSelector(
  signalsForModules,
  getFeatureModuleName,
  conditionsSelector,
  (allSignals, moduleName, conditions) => {
    if (!allSignals || !moduleName || !conditions) return null
    const moduleSignals = allSignals.get(moduleName)
    if (!moduleSignals) return null

    const activeSignalUris = new Set()
    conditions.forEach((condition) => {
      const signalUri = condition.get('signal')
      if (signalUri) activeSignalUris.add(signalUri)
    })

    if (activeSignalUris.size === 0) return null

    let found = null
    moduleSignals.forEach((signal) => {
      if (found !== null) return false
      const uri = signal.get('uri')
      if (!activeSignalUris.has(uri)) return undefined
      const swNum = signal.get('switchNumber')
      if (swNum != null) {
        found = swNum
        return false
      }
      return undefined
    })
    return found
  }
)
